import React from "react";
import Button from "../../../UI/Button";

export default function Modal({ handleModal, text, desc = true }) {
  return (
    <div className="schedule__modal">
      <div className="schedule__modal-content">
        <div className="schedule__modal-image">
          <img src="/assets/icons/congrats.svg" alt="congrats" />
        </div>
        <div className="schedule__modal-title">{text || 'Job has been placed!'}</div>
        <p className="schedule__modal-descr">
          {desc && 'Once this job is scheduled, you will have access to message the technician directly.'}
        </p>
        <div className="schedule__modal-btn">
          <Button onClick={handleModal} text="Continue" />
        </div>
      </div>
      <div className="schedule__modal-bg" onClick={handleModal}></div>
    </div>
  );
}
